export var MatrixRuleDesignerFeature;
(function (MatrixRuleDesignerFeature) {
    MatrixRuleDesignerFeature[MatrixRuleDesignerFeature["Debug"] = 0] = "Debug";
    MatrixRuleDesignerFeature[MatrixRuleDesignerFeature["UndoRedo"] = 1] = "UndoRedo";
    MatrixRuleDesignerFeature[MatrixRuleDesignerFeature["EntityActions"] = 2] = "EntityActions";
    MatrixRuleDesignerFeature[MatrixRuleDesignerFeature["CreateCheckpoints"] = 3] = "CreateCheckpoints";
    MatrixRuleDesignerFeature[MatrixRuleDesignerFeature["Integration"] = 4] = "Integration";
})(MatrixRuleDesignerFeature || (MatrixRuleDesignerFeature = {}));
;
